import { render, staticRenderFns } from "./supplierVerity.vue?vue&type=template&id=349877c1"
import script from "./supplierVerity.vue?vue&type=script&lang=js"
export * from "./supplierVerity.vue?vue&type=script&lang=js"
import style0 from "./supplierVerity.vue?vue&type=style&index=0&id=349877c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports